import { toast } from "react-toastify";
import baseAPI from "../api/baseApi";
import { authHeader, authHeaderWithImage } from "../helpers/authHeader";

const getChatList = async () => {
  try {
    const formdata = new FormData();

    const res = await baseAPI.post(`/chat-list`, formdata, {
      headers: authHeader(),
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

const sendMessage = async (data) => {
  try {
    const res = await baseAPI.post(`/send-message`, data, {
      headers: authHeader(),
    });
    return res.data;
  } catch (error) {
    console.log(error);
    toast.error(error?.response?.data?.message);
  }
};

const getMessageList = async (data) => {
  try {
    const formdata = new FormData();

    formdata.append("chat_unique_key", data?.chat_unique_key);
    formdata.append("page", data?.page);

    const res = await baseAPI.post(`/message-list`, formdata, {
      headers: authHeader(),
    });
    return res.data;
  } catch (error) {
    toast.error(error?.response?.data?.message);
    if (error?.response?.data?.status == 2) {
      window.location.href = "/bestalert/chats";
    }
    console.log("errord", error?.response?.data?.status);
  }
};

const ChatService = {
  getChatList,
  getMessageList,
  sendMessage,
};

export default ChatService;
